export const AML_STATUSES = {
  // case 1: popUp Homepage and company data
  NON_COMPLIANT: 'NON_COMPLIANT', // if !survey_updating
  ADMIN_NON_COMPLIANT: 'ADMIN_NON_COMPLIANT',
  BLOCKED: 'BLOCKED', // copy is different if survey_updating is true or false
  ADMIN_BLOCKED: 'ADMIN_BLOCKED',
  ADMIN_COMPLIANT: 'ADMIN_COMPLIANT',
  // case 2: popUp only in company data
  COMPLIANT: 'COMPLIANT',
  RELATED_DATA_NON_PRESENT: 'RELATED_DATA_NON_PRESENT', // dati incompleti
  PERSONAL_DATA_UNDEFINED: 'PERSONAL_DATA_UNDEFINED', // dati in aggiornamento
  // case 3: not manage
  // ADMIN_COMPLIANT: 'ADMIN_COMPLIANT',
  NON_ELIGIBLE: 'NON_ELIGIBLE',
  ADMIN_PERSONAL_DATA_UNDEFINED: 'ADMIN_PERSONAL_DATA_UNDEFINED',
  PERSONAL_DATA_NON_PRESENT: 'PERSONAL_DATA_NON_PRESENT',
  ADMIN_RELATED_DATA_NON_PRESENT: 'ADMIN_RELATED_DATA_NON_PRESENT',
  SURVEY_SUBMITTED: 'SURVEY_SUBMITTED'
}
